export default __webpack_public_path__ + "static/media/BrainBreak cards61.eff5e9d7.png";